import { forOwn } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'components/Layout/Table';
import { getFeedback } from 'store/slices';
import ViewAllFeedbackPopup from './ViewAll';
import Button from 'components/form/Button';
import FeedbackReplyPopup from 'pages/Layout/FeedbackReplyPopup';

const categoryIcon = {
  Other: <i className="bi bi-bullseye me-1" />,
  Bug: <i className="bi bi-bug me-1" />,
  Compliment: <i className="bi bi-hand-thumbs-up me-1" />,
  'Content Error': <i className="bi bi-file-earmark me-1" />,
  Suggetion: <i className="bi bi-chat me-1" />,
};
const opinionIcon = {
  1: <i className="bi bi-emoji-angry color-title-navy" />,
  2: <i className="bi bi-emoji-frown color-title-navy" />,
  3: <i className="bi bi-emoji-neutral color-title-navy" />,
  4: <i className="bi bi-emoji-smile color-title-navy" />,
  5: <i className="bi bi-emoji-laughing color-title-navy" />,
};

const Feedback = ({ filterKey = '' }) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const [isFeedBackReply, setIsFeedBackReply] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [feedbackList, setFeedbackList] = useState({});
  const [viewList, setViewList] = useState([]);
  // const fetchFeedback = async () => {
  //   const response = await dispatch(getFeedback());
  //   let resData = response?.data || [];
  //   const sortData = {};
  //   resData?.forEach((el) => {
  //     const arr = sortData[el.user_id] || [];
  //     sortData[el.user_id] = [...arr, el];
  //   });
  //   setFeedbackList(sortData);
  //   setIsLoading(false);
  // };

  const fetchFeedback = async () => {
    setIsLoading(true);

    // Manually construct query string
    const queryString = filterKey
      ? `?type=${encodeURIComponent(filterKey)}`
      : '';

    const response = await dispatch(getFeedback(queryString));
    let resData = response?.data || [];
    const { unread_count, ...feedbackData } = resData;

    const sortData = {};
    Object.values(feedbackData).forEach((el) => {
      const arr = sortData[el.user_id] || [];
      sortData[el.user_id] = [...arr, el];
    });
    setFeedbackList(sortData);
    setIsLoading(false);
  };

  const {
    view: viewAccess,
    create: createAccess,
    // update: updateAccess,
    // delete: deleteAccess,
  } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'My Post and Networks'
    )?.sub_permission || {};

  useEffect(() => {
    fetchFeedback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterKey]);

  const header = [
    {
      title: 'Name',
    },
    {
      title: 'Comments',
    },
  ];

  const rowData = [];
  const feedbackArray = Object.values(feedbackList);
  const filteredFeedback =
    filterKey === 'membership' ? feedbackArray.slice(0, 5) : feedbackArray;

  forOwn(filteredFeedback, (value) => {
    const { user_name, message, category, opinion } = value[0] || {};
    let obj = [
      {
        value: <div className="text-start">{user_name}</div>,
      },
      {
        value: (
          <div className="d-flex justify-content-between align-items-center ps-2 pe-2">
            <div className="d-flex align-items-start flex-wrap gap-2 ps-2 pe-2">
              <div className="text-start d-flex align-items-center flex-wrap">
                <span> {message}</span>
                {category && (
                  <span className="pt-1 pb-1 ps-2 pe-2 ms-1 bg-title-navy color-white text-12-400 text-nowrap">
                    {categoryIcon[category]}
                    {category}
                  </span>
                )}
                {opinion && (
                  <span className="ms-2 text-18-400">
                    {opinionIcon[opinion]}
                  </span>
                )}
              </div>
              {viewAccess === '1' && (
                <div
                  className={`color-new-car text-14-400 pointer text-nowrap mt-1 ${
                    value.length <= 1 ? 'd-none' : ''
                  }`}
                  onClick={() => {
                    setViewList(value);
                  }}
                >
                  View All ({value.length})
                </div>
              )}
            </div>
            {createAccess === '1' && (
              <Button
                className="color-new-car gap-2"
                text="Reply"
                icon={<i className="bi bi-reply-fill color-new-car"></i>}
                onClick={() => {
                  setIsFeedBackReply(value);
                }}
              />
            )}
          </div>
        ),
      },
    ];
    rowData.push({ data: obj });
  });
  return (
    <>
      {isFeedBackReply && (
        <FeedbackReplyPopup
          onHide={() => {
            setIsFeedBackReply(null);
          }}
          isFeedBackReply={isFeedBackReply}
          categoryIcon={categoryIcon}
          opinionIcon={opinionIcon}
        />
      )}
      {viewList.length > 0 && (
        <ViewAllFeedbackPopup
          categoryIcon={categoryIcon}
          opinionIcon={opinionIcon}
          list={viewList}
          onHide={() => {
            setViewList([]);
          }}
        />
      )}
      <Table isLoading={isLoading} header={header} rowData={rowData} />
    </>
  );
};
export default Feedback;
